import { lazy, ComponentType } from "react";

type LazyFactory = () => Promise<{ default: ComponentType<any> }>;

const PAGE_RELOAD_KEY = "chunk-reload";

export function lazyWithRetry(factory: LazyFactory) {
  return lazy(() =>
    factory().catch((error: unknown) => {
      const hasReloaded = sessionStorage.getItem(PAGE_RELOAD_KEY);

      if (!hasReloaded) {
        sessionStorage.setItem(PAGE_RELOAD_KEY, "true");
        window.location.reload();
        return new Promise(() => {});
      }

      sessionStorage.removeItem(PAGE_RELOAD_KEY);
      throw error;
    }),
  );
}

if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    sessionStorage.removeItem(PAGE_RELOAD_KEY);
  });
}
